import { Box, Button, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import Page from '../../component/Page'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import api from '../../api/api'
import { SETTING_CONFIG } from './config.';
import Swal from 'sweetalert2';

export default function ChangePassword() {
    const [Password, setPassword] = useState('');
    const [NewPassword, setNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordC, setShowPasswordC] = useState(false);
    const [Check, setCheck] = useState(false);
    const [Check2, setCheck2] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickShowPasswordC = () => setShowPasswordC((showC) => !showC);
    const handleMouseDownPasswordC = (event) => {
        event.preventDefault();
    };

    const handleSubmit = () => {
        const body = {
            Password: NewPassword
        }

        const ChangePassword = async () => {
            const res = await api.put(SETTING_CONFIG.requests.ChangePassword.url, body)
            const data = res.data
            if (data.status === true) {
                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
                setNewPassword('')
                setPassword('')
            }else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        }
        if (NewPassword.length === 0) {
            setCheck2(true)
        }
        if (Password.length === 0) {
            setCheck(true)
        }
        if (NewPassword.length > 0 && Password.length > 0) {
            if (NewPassword === Password) {
                ChangePassword()
            }
        }



    }


    return (
        <Page>
            <div class="container-fluid">
                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-12 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            เปลี่ยนรหัสผ่าน
                        </label>


                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 col-sm-12 ">
                        <label class="labelInput">รหัสผ่านใหม่</label>
                        <Box className={`backgroundField ${Check2 ? 'error' : ''}`} >
                            <TextField value={NewPassword} onChange={e => setNewPassword(e.target.value)} variant="standard" fullWidth
                                type={showPassword ? 'text' : 'password'}
                                sx={{
                                    "input::-ms-reveal, input::-ms-clear": {
                                        display: 'none',
                                    }
                                }}
                                onBlur={e => {
                                    if (e.target.value.length === 0) {
                                        setCheck2(true)
                                    } else {
                                        setCheck2(false)
                                        setCheck(true)
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                        </Box>
                        {Check2 && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกรหัสผ่าน</span>}

                    </div>

                </div >
                <div class="row" style={{ marginBottom: '20px', marginTop: "20px" }}>
                    <div class="col-lg-4 col-sm-12 ">
                        <label class="labelInput">ยืนยันรหัสผ่านใหม่</label>
                        <Box className={`backgroundField ${Check ? 'error' : ''}`}  >
                            <TextField value={Password} onChange={e => {
                                setPassword(e.target.value)

                            }}
                                onBlur={e => {
                                    if (e.target.value !== NewPassword) {
                                        setCheck(true)
                                    } else {
                                        setCheck(false)
                                    }
                                }}
                                variant="standard" fullWidth
                                type={showPasswordC ? 'text' : 'password'}
                                sx={{
                                    "input::-ms-reveal, input::-ms-clear": {
                                        display: 'none',
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordC}
                                            onMouseDown={handleMouseDownPasswordC}
                                            edge="end"
                                        >
                                            {showPasswordC ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                        </Box>
                    </div >
                    {Password && Check && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกให้ตรงกับรหัสผ่านใหม่</span>}
                </div >
                <hr class="chr" />
                <div class="col-12 text-left mt-3">
                    <Button type="button" className="ButtomSearch" variant='contained' onClick={handleSubmit}>บันทึก</Button>
                </div >
            </div >
        </Page >
    )
}
